var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "776px",
    height: "776px",
    viewBox: "0 0 776 776",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(285.000000, 489.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    fill: "#ED5353",
    points: "19.4636142 11.5349041 39.6563931 0.907050614 81.8071328 84.2544428 62.9050285 94.2170517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8338679,68.3397605 C77.4380479,91.8888129 54.7676249,103.889166 32.2158899,95.1405149 C9.66315761,86.3928657 -4.2383099,60.2100047 1.16548914,36.6599509 C6.56928817,13.1098971 29.2327296,1.11154728 51.7854619,9.85919655 C74.3361995,18.6078473 88.2396617,44.7897067 82.8338679,68.3397605",
    id: "Fill-13",
    fill: "#FF7878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2930981,72.3138799 C30.8986584,73.5991192 31.5042188,74.8843584 32.1107702,76.1686083 C32.6529003,77.3173094 34.0959377,78 35.3100317,78 C36.7332472,78 37.7015491,77.2460721 38.5102843,76.1686083 C41.4280743,72.2782613 44.3478464,68.3879143 47.2616719,64.4975674 C51.9198284,58.2890406 56.5779849,52.0805138 61.2262304,45.8729764 C62.3065263,44.436358 63.3868221,43.0017183 64.457207,41.5660893 C65.6564346,39.9662187 64.7148923,37.4323483 63.1291369,36.5052742 C61.2361414,35.400107 59.2638581,36.2272509 58.0547196,37.8320685 C55.1408941,41.7224155 52.2270685,45.6127625 49.303332,49.5021201 C44.7988689,55.5195597 40.5707071,61.2198422 36.0583951,67.2362664 C32.5941834,59.8931618 29.1300956,52.5504576 25.6666567,45.2071058 C25.0591142,43.9228559 24.4535538,42.6376167 23.8479935,41.3533668 C22.9946588,39.5457209 20.3950111,39.0806997 18.7785317,40.0255831 C16.9231979,41.1089834 16.5921714,43.2738052 17.4484793,45.0873876 C21.7300189,54.1622254 26.0105674,63.2380527 30.2930981,72.3138799 Z",
    id: "Fill-14",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.8d98543ca84d0c948fdce5e654741d61.svg";
export { ForwardRef as ReactComponent };